import type { Props } from "../../../../props";

type Area = Props["groupedPrefectures"][number];

export const convertStateForCollapse =
  (code: string) =>
  (area: Area): Area => {
    const { code: areaCode, isOpened } = area;
    if (areaCode !== code) return area;
    return {
      ...area,
      isOpened: !isOpened,
    };
  };
